/* custom js here */
$(document).ready(function() {
    //show the calculator widget if selling plan is set.
    // setTimeout(function() {
    //     var current_url = location.href;
    //     if(current_url.includes("selling_plan")) {
    //         $(".ws_configurator_widget").show();
    //     } else {
    //         $(".ws_configurator_widget").hide();
    //     }
    // }, 1000);

    $(document).on("click", ".autoship-product", function() {
        var product_link = $(this).data("link");
        localStorage.setItem("autoship", "true");
        location.href = product_link;
        //$(".bold-ro__recurring-lbl").find(".bold-ro__mixed-radio-btn").prop("checked", true).trigger("click");
    });

    // $(document).on("click", "#ws_configurator_submit", function(e) {
    //     e.preventDefault();
    //     var $target = $(this);
    //     //console.log("add to cart");
    //     //var bold_selector = $(".bold-ro__recurring-lbl").find('[name="bold-ro__selector_radio_button"]:checked').val();
    //     var variant_id = $("[data-variant-selector]").find('option:checked').val();
    //         $.ajax({
    //             type: "POST",
    //             url: "/cart/change.js",
    //             dataType: "json",
    //             data: {
    //                 id: variant_id,
    //                 quantity: 0,
    //             },
    //             }).then((data) => {
    //             console.log("removed successfully");
    //             $target.trigger("click");
    //         }); 
    // });
});